import React from "react";
import { ArrowUp, ArrowDown } from "lucide-react";

const columns = [
  { key: "year", label: "Year", searchable: true, sortable: true },
  { key: "period", label: "Period", searchable: true, sortable: true },
  { key: "week", label: "Week", searchable: true, sortable: true },
  { key: "productNames", label: "Downstream Products", searchable: true, sortable: true },
  { key: "name", label: "Users", searchable: true, sortable: true },
  { key: "count", label: "Event Count", searchable: true, sortable: true, align: "left" },
];

const BusinessTableHeader = ({
  sortBy,
  sortOrder,
  columnSearch = {},
  onSortChange,
  onSearchChange,
}) => {
  const handleSort = (columnKey) => {
    const col = columns.find((c) => c.key === columnKey);
    let newOrder = "asc";
    if (!col?.sortable) return;

    if (sortBy === columnKey) {
      newOrder = sortOrder === "asc" ? "desc" : "asc";
    }
    onSortChange(columnKey, newOrder);
  };

  const renderSortIcon = (columnKey) => {
    const col = columns.find((c) => c.key === columnKey);
    if (!col?.sortable) return null;

    if (sortBy === columnKey) {
      return sortOrder === "asc" ? (
        <ArrowUp size={12} />
      ) : (
        <ArrowDown size={12} />
      );
    }
    return <ArrowUp size={12} style={{ opacity: 0.9 }} />;
  };

  return (
    <thead>
      {/* Sort Row */}
      <tr className="bg-[#F0FDFA]">
        {columns.map((col) => (
          <th
            key={col.key}
            onClick={() => handleSort(col.key)}
            className={`px-5 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wide 
              ${col.align === "right" ? "text-right" : "text-left"} 
              ${col.sortable ? "cursor-pointer" : ""}`}
          >
            <div className="flex items-center gap-1">
              {col.label}
              {renderSortIcon(col.key)}
            </div>
          </th>
        ))}
      </tr>

      {/* Search Row */}
      <tr className="bg-[#F0FDFA] border-b border-blue-100">
        {columns.map((col) => (
          <th key={`search-${col.key}`} className="px-5 pb-2">
            {col.searchable ? (
              <input
                className="w-full font-normal text-xs px-2 py-1 rounded border-none outline-none"
                placeholder="Search"
                value={columnSearch[col.key] || ""}
                onChange={(e) =>
                  onSearchChange(col.key, e.target.value)
                }
                onClick={(e) => e.stopPropagation()}
              />
            ) : (
              <div className="h-6" />
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default BusinessTableHeader;